import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeShowForm } from "../store/reducers/thunk";
import { RootState } from "../store/store";

export const useSidenav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const showForm = useSelector((state: RootState) => (state as any).showForm.showForm);

  const handleCloseMenu = () => {
    dispatch(changeShowForm(false));
    setIsMenuOpen(false);
  };

  const handleOpenMenu = () => {
    setIsMenuOpen(true);
  };

  const handleShowForm = () => {
    dispatch(changeShowForm(true));
    setIsMenuOpen(true);
  };

  const handleHideForm = () => {
    dispatch(changeShowForm(false));
  };

  useEffect(() => {
    // Si showForm se activa desde Redux (ej: desde el footer), abrir el menú
    if (showForm) {
      setIsMenuOpen(true);
    }
  }, [showForm]);

  return {
    showForm,
    isMenuOpen,
    handleCloseMenu,
    handleOpenMenu,
    handleShowForm,
    handleHideForm,
  };
};
